import React from "react";
import * as Icons from "lucide-react";
import { documentation } from "../mock";

export default function Documentation() {
  return (
    <section className="py-16 lg:py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">We Help You With <span className="text-teal-600">DOCUMENTATION</span></h2>
          <p className="mt-3 text-slate-600">We guide you in preparing the exact paperwork needed to guarantee smooth customs clearance.</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {documentation.map((d) => {
            const Icon = Icons[d.icon] || Icons.FileText;
            return (
              <div key={d.title} className="flex gap-4 bg-white rounded-2xl p-6 border border-slate-100 card-shadow hover:-translate-y-0.5 transition-transform">
                <div className="w-12 h-12 rounded-xl bg-teal-50 text-teal-600 flex items-center justify-center shrink-0">
                  <Icon className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 mb-1.5">{d.title}</h4>
                  <p className="text-sm text-slate-500 leading-relaxed">{d.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
